export const PLACEHOLDER_ELEMENT = 'placeholder_mention';
export const PLACEHOLDER_ELEMENT_INPUT = 'placeholder_mention_input';
